var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.362,44.453c0.586-1.379,0.912-2.894,0.912-4.485v-7.554c0-1.75-0.405-3.404-1.107-4.89 c1.316-2.527,1.147-7.02,0.738-8.007c-0.323-0.781-1.132-1.278-1.945-1.232c-0.812,0.04-1.518,0.567-1.787,1.329 c-0.246,0.421-1.306,1.441-2.489,2.419c-1.49-0.707-3.149-1.115-4.905-1.115h-7.555c-1.756,0-3.415,0.407-4.905,1.114 c-1.184-0.978-2.244-1.998-2.49-2.419c-0.27-0.761-0.974-1.288-1.787-1.328c-0.858-0.038-1.622,0.451-1.945,1.23 c-0.41,0.988-0.58,5.482,0.738,8.009c-0.702,1.486-1.107,3.139-1.107,4.889v7.554c0,1.59,0.325,3.106,0.911,4.484 c-2.297,3.082-3.558,6.828-3.558,10.692c0,10.161,8.269,22.572,17.92,22.572c9.651,0,17.92-12.411,17.92-22.572 C65.92,51.281,64.658,47.536,62.362,44.453z M51.777,24.918c4.134,0,7.496,3.363,7.496,7.496v7.554 c0,4.133-3.362,7.496-7.496,7.496h-7.555c-4.133,0-7.496-3.363-7.496-7.496v-7.554c0-4.133,3.362-7.496,7.496-7.496H51.777z  M48,73.717c-6.136,0-13.92-8.744-13.92-18.572c0-2.488,0.669-4.917,1.915-7.04c2.097,2.119,4.981,3.36,8.028,3.36h0.2h7.555h0.2 c3.047,0,5.931-1.241,8.027-3.36c1.246,2.123,1.915,4.551,1.915,7.04C61.92,64.973,54.136,73.717,48,73.717z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.368,64.348h-2.766c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.766c1.104,0,2-0.896,2-2S55.473,64.348,54.368,64.348z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.03,40.932c0.406,0.564,0.735,1.364,0.975,2.001c0.497,1.019,1.023,2.048,1.695,3.002c0.14,0.204,0.46,0.205,0.6,0 c0.672-0.956,1.197-1.983,1.695-3.002c0.24-0.635,0.57-1.441,0.975-2.002c0.697-1.406-1.542-2.53-2.67-3.002 c-0.591-0.205-1.202,0.314-1.669,0.5C45.753,38.988,44.457,39.841,45.03,40.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.397,64.348h-2.766c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.766c1.104,0,2-0.896,2-2S45.502,64.348,44.397,64.348z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.015,
    cy: 32.352,
    r: 2.486
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.985,
    cy: 32.352,
    r: 2.486
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwl);
export default __webpack_public_path__ + "static/media/owl.6be3dbad1312df307e91dcab60d08856.svg";
export { ForwardRef as ReactComponent };